
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 3h18v14H1V3z","stroke":"#666","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.192 14H5.683V9.87l.015-.68.024-.742a7.84 7.84 0 01-.522.493l-.82.66-.728-.909 2.3-1.83h1.24V14zm1.954-.698c0-.274.073-.48.22-.62.146-.14.359-.21.639-.21.27 0 .478.071.625.215.15.143.224.348.224.615 0 .257-.074.46-.224.61-.15.147-.358.22-.625.22-.274 0-.485-.072-.635-.215-.15-.146-.224-.352-.224-.615zm0-4.033c0-.274.073-.48.22-.62.146-.14.359-.21.639-.21.27 0 .478.071.625.214.15.144.224.349.224.616 0 .263-.076.468-.229.615-.15.143-.356.215-.62.215-.274 0-.485-.072-.635-.215-.15-.143-.224-.349-.224-.615zM15.356 14h-1.508V9.87l.014-.68.025-.742c-.25.25-.425.415-.523.493l-.82.66-.727-.909 2.3-1.83h1.24V14z","fill":"#666"}})])
          )
        }
      }
    